import { render, staticRenderFns } from "./SupplierOrderCreateUpdate.vue?vue&type=template&id=3f51ff4a&scoped=true&"
import script from "./SupplierOrderCreateUpdate.vue?vue&type=script&lang=js&"
export * from "./SupplierOrderCreateUpdate.vue?vue&type=script&lang=js&"
import style0 from "./SupplierOrderCreateUpdate.vue?vue&type=style&index=0&id=3f51ff4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f51ff4a",
  null
  
)

export default component.exports